import React from "react";
import styled from "styled-components";

const CtaBgCircle = styled.div`
  background-image: url(assets/img/home-01/cta-bg.png);
  background-size: contain;
  transform: translate(0px, 0px);
`;

const CtaTitle = styled.h5`
  opacity: 1;
  transform: translate(0px, 0px);

  @media (max-width: 767px) {
    font-size: 30px;
    line-height: 1.25;
  }
  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

const VideoWrap = styled.div`
  .tp-video-thumb {
    img,
    video {
      max-width: 100%;
      height: auto;
    }
  }
`;

const DesignWorkArea = styled.div`
  display: none;
`;

const DesignWorkText = styled.p`
  color: black;
`;

const WorkVideoArea = () => {
  return (
    <>
      <div className="st-cta-area st-cta-ptb p-relative pb-60" style={{marginTop: 40}}>
        <CtaBgCircle
          className="st-cta-bg-circle"
          data-background="assets/img/home-01/cta-bg.jpg"
        ></CtaBgCircle>
        <div className="container container-1320">
          <div className="row">
            <div className="col-lg-12">
              <div className="st-cta-wrapper text-center z-index-1">
                <CtaTitle className="tp-section-title-playfair mb-40 tp_fade_anim" data-delay=".3">
                  Providing Quality Foods to Meet Today's Customer Needs! <br /> <span></span>
                </CtaTitle>
              </div>
            </div>
          </div>
        </div>
      </div>

      <DesignWorkArea className="design-work-area p-relative pt-140 pb-140">
        <div className="design-work-content">
          <img className="tp_fade_anim" src="/assets/img/home-01/hero/hero-video-1.png" alt="" />
          <DesignWorkText className="tp_reveal_anim">
            PRODUCERS OF PIZZA CHEESE AND CHICKEN FINGER FOODS
          </DesignWorkText>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="design-work-wrapper">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-1">
                      <img src="assets/img/home-01/foods/1.jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-2">
                      <img src="assets/img/home-01/foods/2.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="design-work-wrapper">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-1">
                      <img src="assets/img/home-01/foods/3.jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-2">
                      <img src="assets/img/home-01/foods/4.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="design-work-wrapper">
                <div className="row">
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-1">
                      <img src="assets/img/home-01/foods/5.jpg" alt="" />
                    </div>
                  </div>
                  <div className="col-xl-6">
                    <div className="design-work-item design-work-item-2">
                      <img src="assets/img/home-01/foods/6.jpg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DesignWorkArea>

      <VideoWrap className="tp-video-area black-bg mt-120 fix">
        <div className="container-fluid p-0">
          <div className="tp-video-thumb-wrap">
            <div className="tp-video-thumb d-none d-xl-block">
              <img src="assets/img/home-01/foods/2.jpg" alt="" />
            </div>
            <div className="tp-video-thumb mb-25">
              <video loop muted autoPlay playsInline>
                <source src="assets/img/home-01/video/v2.mp4" type="video/mp4" />
              </video>
            </div>
            <div className="tp-video-thumb d-none d-xl-block mb-25">
              <img src="assets/img/home-01/foods/6.jpg" alt="" />
            </div>
            <div className="tp-video-thumb d-none d-xl-block mb-25">
              <img src="assets/img/home-01/foods/5.jpg" alt="" />
            </div>
            <div className="tp-video-thumb d-none d-xl-block">
              <img src="assets/img/home-01/foods/4.jpg" alt="" />
            </div>
            <div className="tp-video-thumb d-none d-xl-block">
              <img src="assets/img/home-01/foods/1.jpg" alt="" />
            </div>
          </div>
        </div>
      </VideoWrap>
    </>
  );
};

export default WorkVideoArea;
